function EventBusService() {
    var _topics = {};

    var checkExistance = () => {
        if( $.pcg.frontend.eventBus instanceof EventBusService){
            throw "EventBus is already exist"; 
        }
    };

    this.subscribe = (topic, listener) => {
        if (!_topics[topic]) {
            _topics[topic] = [];
        };

        _topics[topic].push(listener);
    };

    this.unsubscribe = (topic, listener) => {
        if(_topics.hasOwnProperty(topic)){
            var index = _topics[topic].indexOf(listener);
            if(index > -1){
                _topics[topic].splice(index, 1);
            }
        }
    };

    this.publish = (topic, data) => {
        if (!_topics[topic] || _topics[topic].length < 1) 
        {
            return;
        }

        _topics[topic].forEach(function(listener) {
            listener(data || {});
        });
    }

    Object.defineProperty(this, "topics", {
        get: () => _topics
    });

    checkExistance();

    Object.seal(this);
    Object.freeze(this);

    return this;
};

module.exports = EventBusService;